import { Container, Reveal } from "./common";

const chapters = [
    {
        n: "01",
        title: "Clarity over complexity",
        text: "A CRM your team opens every morning because it makes the day simpler — not another system they work around.",
    },
    {
        n: "02",
        title: "Speed to every lead",
        text: "The team that responds first usually wins. Kryvo routes, reminds and follows up in minutes, not days.",
    },
    {
        n: "03",
        title: "Context-driven selling",
        text: "Every call, email, visit and message lives on one timeline, so no conversation ever starts from zero.",
    },
    {
        n: "04",
        title: "Built to scale with you",
        text: "Start with five users and a spreadsheet import. Grow into automation, field teams and deep analytics — same platform.",
    },
];

const Manifesto = () => (
    <section id="manifesto" data-testid="manifesto-chapters-section" className="bg-white py-20 lg:py-28">
        <Container>
            <Reveal>
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#16A34A]">
                    The Kryvo Way
                </p>
                <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-[#111827] sm:text-4xl">
                    Four principles behind everything we build.
                </h2>
            </Reveal>
            <div className="mt-14 grid gap-x-12 gap-y-0 md:grid-cols-2">
                {chapters.map((c, i) => (
                    <Reveal key={c.n} delay={(i % 2) * 0.08}>
                        <div className="group flex gap-6 border-t border-[#E5E7EB] py-9 transition-colors">
                            <span className="font-display text-4xl font-extrabold tracking-tight text-[#E5E7EB] transition-colors duration-300 group-hover:text-[#16A34A] sm:text-5xl">
                                {c.n}
                            </span>
                            <div>
                                <h3 className="font-display text-xl font-bold text-[#111827]">{c.title}</h3>
                                <p className="mt-2 max-w-md text-[15px] leading-relaxed text-[#64748B]">{c.text}</p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </Container>
    </section>
);

export default Manifesto;
